import React from "react";
import { useSelector } from "../../store";
import { Box, Container, Typography } from "@mui/material";
import PageTitle from "../base/PageTitle";
import Downloads from "../views/Downloads";

interface Props {}

const DownloadPage: React.FC<Props> = (props) => {
  const { globalLoadingState } = useSelector((store) => store.shared);

  return !globalLoadingState.isLoading ? (
    <Container>
      <PageTitle title="Download SVPro Security Hub" />
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="center"
        alignContent="center"
        justifyItems="center"
        alignItems="center"
        paddingY={3}
      >
        <Typography variant="h4" textAlign="center">
          Get our enterprise-grade security solution for your preferred
          platform. SVPro Security Hub provides comprehensive protection for
          your infrastructure.
        </Typography>
      </Box>
      <Downloads />
    </Container>
  ) : (
    <></>
  );
};

export default DownloadPage;
